import { useEffect, useState } from 'react';
import { Toaster, toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const FLAG = 'tapelligence-demo-mode';

const saveFlag = (on) => (on ? localStorage.setItem(FLAG, 'true') : localStorage.removeItem(FLAG));

// Super admin only: Demo mode switch + "Demo mode on" pill for the admin bar
export const DemoModeToggle = () => {
  const [enabled, setEnabled] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    fetch(`${API_URL}/api/auth/demo-mode`, { credentials: 'include' })
      .then(r => (r.ok ? r.json() : { enabled: false }))
      .then(d => { setEnabled(d.enabled); saveFlag(d.enabled); })
      .catch(() => {});
  }, []);

  const toggle = async () => {
    setBusy(true);
    try {
      const res = await fetch(`${API_URL}/api/auth/demo-mode`, {
        method: 'POST', credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ enabled: !enabled }),
      });
      if (!res.ok) throw new Error();
      const d = await res.json();
      setEnabled(d.enabled);
      saveFlag(d.enabled);
      toast.success(d.enabled
        ? 'Demo mode ON: you stay logged in for 60 minutes after your last activity (at least 8 hours from login). Turns off at midnight Eastern.'
        : 'Demo mode OFF: normal 8-hour session.');
    } catch {
      toast.error('Could not change Demo mode. Please try again.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex items-center gap-2" data-testid="demo-mode-control">
      <Toaster position="top-center" richColors />
      {enabled && (
        <span data-testid="demo-mode-pill" className="px-2 py-0.5 rounded-full bg-orange-100 text-[#fd7f00] text-[10px] font-bold tracking-wider uppercase whitespace-nowrap">
          Demo mode on
        </span>
      )}
      <button
        type="button" role="switch" aria-checked={enabled} disabled={busy} onClick={toggle}
        data-testid="demo-mode-switch" title="Demo mode"
        className="inline-flex items-center gap-1.5 px-2 py-1 rounded-lg text-slate-500 hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors disabled:opacity-50"
      >
        <span className="whitespace-nowrap">Demo</span>
        <span className={`relative w-7 h-4 rounded-full transition-colors ${enabled ? 'bg-[#fd7f00]' : 'bg-slate-300'}`}>
          <span className={`absolute top-0.5 left-0.5 w-3 h-3 rounded-full bg-white transition-transform ${enabled ? 'translate-x-3' : ''}`} />
        </span>
      </button>
    </div>
  );
};
